import { render, staticRenderFns } from "./cancelSVIPConfirm.vue?vue&type=template&id=3d7183de&"
import script from "./cancelSVIPConfirm.vue?vue&type=script&lang=js&"
export * from "./cancelSVIPConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d7183de')) {
      api.createRecord('3d7183de', component.options)
    } else {
      api.reload('3d7183de', component.options)
    }
    module.hot.accept("./cancelSVIPConfirm.vue?vue&type=template&id=3d7183de&", function () {
      api.rerender('3d7183de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/vip/cancelSVIPConfirm.vue"
export default component.exports